import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const SignInPagePageGetContentContext = React.createContext({});
export let signInPageGetContentMachine: any;

const MODULE_NAME = 'machines.signinPage.GetPageContent';

export const useSMSignInPageGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  signInPageGetContentMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(signInPageGetContentMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    signInPageGetContentMachine,
    signInPageGetContentState: state,
    signInPageGetContentSend: send,
  };
};
